import {Component, inject, OnInit} from '@angular/core';
import {CmsApiService} from '../../../core/cms-api.service';
import {AConst} from '../../../core/a-const.enum';

@Component({
    selector: 'app-admin-settings-faq',
    templateUrl: './admin-settings-faq.component.html',
    styleUrls: ['./admin-settings-faq.component.scss'],
    standalone: false
})
export class AdminSettingsFaqComponent implements OnInit {
  private readonly cms: CmsApiService = inject(CmsApiService);

  adminSettingsFq = [];
  AConst = AConst;

  ngOnInit() {
    this.getFaq();
  }

  private getFaq() {
    this.cms.getFaq({category: 'settings'}).then((data) => {
        this.adminSettingsFq = data[AConst.FAQ];
      },
      function (failed) {
        console.error('This failed! ' + failed.message);
      }
    );
  }

}
